import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import DAProtect from '@wix/da-ds/pkg/Icons/24x24/DAProtect';
import s from './DaProtectNotice.scss';

interface Props {}

const DaProtectNotice: React.FC<Props> = () => {
  const { t } = useTranslation();
  const onClick = useCallback((e: React.MouseEvent) => {
    window.location.assign(
      'https://www.deviantartsupport.com/en/article/what-is-deviantart-protect'
    );
    e.preventDefault();
  }, []);

  return (
    <>
      <br />
      <div className={s['da-protect-heading']}>
        <DAProtect className={s['da-protect-icon']} disableDefaultColors />
        {t('daProtect.submit.heading')}
      </div>
      <div className={s['da-protect-content']}>
        {/* prettier-ignore */}
        <Trans i18nKey="daProtect.submit.content">
          DeviantArt has your back...
          <br />
          Now all new submissions enjoy 3 months protection against art
          theft on DeviantArt.
          <span className={s['fake-link']} onClick={onClick}>
            Learn more
          </span>
        </Trans>
      </div>
    </>
  );
};
DaProtectNotice.displayName = 'DaProtectNotice';

export default DaProtectNotice;
